const article = {
    id: 'change-order',
    title: 'Change Order request',
    summary: 'Move a SKU to another order by raising a Change Order request from the Skus page.',
    publishedAt: '2026-08-31',
    tags: ['skus', 'orders'],
    sections: [
        {
            type: 'paragraph',
            text: 'Change Order is a request type on a SKU. You pick the client and the destination order, then confirm. It applies to a single SKU.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when a SKU was created on the wrong order and should move, instead of recreating it.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Skus and raise a request on one SKU.',
                'Choose Change Order.',
                'Select the company and the order the SKU should move to.',
                'Add a comment if you need one, then confirm.',
            ],
        },
        {
            type: 'note',
            text: 'Change Order is not part of a multi-SKU raise. Select a single SKU.',
        },
    ],
};

export default article;
